import { render, staticRenderFns } from "./common_docs_XM.vue?vue&type=template&id=75d26e66"
import script from "./common_docs_XM.vue?vue&type=script&lang=js"
export * from "./common_docs_XM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports